<div mat-dialog-title
     class="title">
  <div class="subtitle">{{ formTitle | translate }}</div>
  <button mat-icon-button
          mat-dialog-close
          tabindex="-1"
          [matTooltip]="'Close' | translate"
          class="close-button hidden">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div>
  <mat-dialog-content>
    <div class="line line-margin">
      <mat-form-field color="primary">
        <mat-select placeholder="{{ 'Team_Attribution' | translate }}"
                    [formControl]="teamsSelectFormControl"
                    multiple
                    #multiSelect>
          <mat-option>
            <ngx-mat-select-search
              [placeholderLabel]="'Search' | translate"
              [noEntriesFoundLabel]="'No_Entries_Found' | translate"
              [formControl]="teamFilterFormControl">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let team of filteredTeams | async" [value]="team">
            {{ team.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="line line-margin">
      <mat-checkbox color="primary"
                    [(ngModel)]="removeCoachAthleteRelations">
        {{ 'Remove_Coach_Athlete_Relations' | translate }}
      </mat-checkbox>
    </div>
    <div class="line line-margin">
      <mat-checkbox color="primary"
                    [(ngModel)]="removeGuestAthleteRelations">
        {{ 'Remove_Guest_Athlete_Relations' | translate }}
      </mat-checkbox>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button
            mat-dialog-close
            tabindex="-1">
      {{ 'Cancel' | translate}}
    </button>
    <button mat-raised-button
            (click)="onSaveClicked()"
            color="accent">
      {{ confirmButtonTitle | translate}}
    </button>
  </mat-dialog-actions>
</div>

<div class="progress-container">
  <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
</div>
